let _initProto, _initClass, _init_label, _init_extra_label, _init_changeEvent, _init_extra_changeEvent;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, event, onEvent, prop } from "@ecopages/radiant";
import { applyRovingTabindex, navigateRovingTabindex } from "@/lib/roving-tabindex";
import { PopoverController, shouldDismissPopoverPointer } from "../shared/popover-controller";
let _RuiMenubar;
class RuiMenubar extends RadiantElement {
  static {
    ({
      e: [_init_label, _init_extra_label, _init_changeEvent, _init_extra_changeEvent, _initProto],
      c: [_RuiMenubar, _initClass]
    } = _applyDecs(this, [customElement("rui-menubar")], [[prop({
      type: String,
      defaultValue: ""
    }), 0, "label"], [event({
      name: "rui-change",
      bubbles: true,
      composed: true
    }), 0, "changeEvent"], [onEvent({
      document: true,
      type: "pointerdown"
    }), 2, "onDocumentPointerDown"], [onEvent({
      selector: '[data-ref="root"] > [data-ref="menubar-root"] > [role="menuitem"]',
      type: "keydown"
    }), 2, "onTopKeydown"], [onEvent({
      selector: '[data-ref="root"] > [data-ref="menubar-root"] > [role="menuitem"]',
      type: "click"
    }), 2, "onTopClick"], [onEvent({
      selector: '[role="menu"] > [role="menuitem"]',
      type: "keydown"
    }), 2, "onMenuKeydown"], [onEvent({
      selector: '[role="menu"] > [role="menuitem"]',
      type: "click"
    }), 2, "onMenuItemClick"]], 0, void 0, RadiantElement));
  }
  label = (_initProto(this), _init_label(this));
  changeEvent = (_init_extra_label(this), _init_changeEvent(this));
  openRoot = (_init_extra_changeEvent(this), null);
  popoverController = null;
  getTopItems() {
    return Array.from(this.querySelectorAll('[data-ref="root"] > [data-ref="menubar-root"] > [role="menuitem"]'));
  }
  getMenuFor(topItem) {
    const root = topItem.closest('[data-ref="menubar-root"]');
    return root?.querySelector(':scope > [role="menu"]') ?? null;
  }
  getMenuItems(menu) {
    return Array.from(menu.querySelectorAll(':scope > [role="menuitem"]')).filter(item => item.getAttribute("aria-disabled") !== "true");
  }
  onConnected() {
    applyRovingTabindex(this.getTopItems(), 0);
  }
  disconnectedCallback() {
    this.popoverController?.destroy();
    this.popoverController = null;
    super.disconnectedCallback();
  }
  getOpenMenuAnchor() {
    if (!this.openRoot) {
      return null;
    }
    return this.openRoot.querySelector(':scope > [role="menuitem"]');
  }
  getOpenMenuSurface() {
    if (!this.openRoot) {
      return null;
    }
    return this.openRoot.querySelector(':scope > [role="menu"]');
  }
  syncOpenMenuPosition() {
    const anchor = this.getOpenMenuAnchor();
    const menu = this.getOpenMenuSurface();
    if (!anchor || !menu) {
      return;
    }
    if (!this.popoverController) {
      this.popoverController = new PopoverController({
        getAnchor: () => this.getOpenMenuAnchor(),
        getFloating: () => this.getOpenMenuSurface(),
        getOpen: () => Boolean(this.openRoot),
        getPlacement: () => "bottom-start",
        gap: 6,
        portal: false
      });
    }
    this.popoverController.updateConfig({
      getAnchor: () => this.getOpenMenuAnchor(),
      getFloating: () => this.getOpenMenuSurface(),
      getOpen: () => Boolean(this.openRoot)
    });
    this.popoverController.sync();
  }
  closeOpenMenu(returnFocus = false) {
    if (!this.openRoot) return;
    const top = this.openRoot.querySelector(':scope > [role="menuitem"]');
    const menu = this.openRoot.querySelector(':scope > [role="menu"]');
    if (top) top.setAttribute("aria-expanded", "false");
    if (menu) menu.hidden = true;
    this.openRoot = null;
    this.popoverController?.teardown();
    if (returnFocus && top) top.focus();
  }
  openMenu(topItem, focus = "first") {
    const root = topItem.closest('[data-ref="menubar-root"]');
    const menu = this.getMenuFor(topItem);
    if (!root || !menu) return;
    if (this.openRoot && this.openRoot !== root) this.closeOpenMenu();
    topItem.setAttribute("aria-expanded", "true");
    menu.hidden = false;
    this.openRoot = root;
    this.syncOpenMenuPosition();
    if (focus === "first") {
      const items = this.getMenuItems(menu);
      applyRovingTabindex(items, 0);
      items[0]?.focus();
    }
  }
  onDocumentPointerDown(event2) {
    if (!this.openRoot) return;
    if (!shouldDismissPopoverPointer(this.getOpenMenuAnchor(), this.getOpenMenuSurface(), event2.target)) {
      return;
    }
    this.closeOpenMenu();
  }
  onTopKeydown(event2) {
    const items = this.getTopItems();
    const current = event2.target.closest('[role="menuitem"]');
    if (!current || !items.includes(current)) return;
    if (event2.key === "ArrowDown" || event2.key === "Enter" || event2.key === " ") {
      if (this.getMenuFor(current)) {
        event2.preventDefault();
        this.openMenu(current, "first");
      }
      return;
    }
    if (event2.key === "Escape") {
      event2.preventDefault();
      this.closeOpenMenu(true);
      return;
    }
    const result = navigateRovingTabindex({
      items,
      current,
      key: event2.key,
      orientation: "horizontal"
    });
    if (!result.handled) return;
    event2.preventDefault();
    if (this.openRoot) {
      if (this.getMenuFor(result.item)) this.openMenu(result.item, "first");else this.closeOpenMenu();
    }
  }
  onTopClick(event2) {
    const current = event2.target.closest('[role="menuitem"]');
    if (!current || !this.getTopItems().includes(current)) return;
    if (!this.getMenuFor(current)) {
      this.closeOpenMenu();
      return;
    }
    const expanded = current.getAttribute("aria-expanded") === "true";
    if (expanded) this.closeOpenMenu();else this.openMenu(current, "first");
  }
  onMenuKeydown(event2) {
    const menu = event2.target.closest('[role="menu"]');
    const current = event2.target.closest('[role="menuitem"]');
    if (!menu || !current || !this.contains(menu)) return;
    const items = this.getMenuItems(menu);
    if (event2.key === "Escape") {
      event2.preventDefault();
      this.closeOpenMenu(true);
      return;
    }
    if (event2.key === "Enter" || event2.key === " ") {
      event2.preventDefault();
      this.activateItem(current);
      return;
    }
    if (event2.key === "ArrowLeft" || event2.key === "ArrowRight") {
      const tops = this.getTopItems();
      const top = menu.parentElement?.querySelector(':scope > [role="menuitem"]');
      if (!top) return;
      event2.preventDefault();
      const result2 = navigateRovingTabindex({
        items: tops,
        current: top,
        key: event2.key,
        orientation: "horizontal"
      });
      if (result2.handled && this.getMenuFor(result2.item)) this.openMenu(result2.item, "first");
      return;
    }
    const result = navigateRovingTabindex({
      items,
      current,
      key: event2.key,
      orientation: "vertical"
    });
    if (result.handled) event2.preventDefault();
  }
  onMenuItemClick(event2) {
    const item = event2.target.closest('[role="menuitem"]');
    if (!item || !this.contains(item)) return;
    if (item.parentElement?.getAttribute("role") !== "menu") return;
    this.activateItem(item);
  }
  activateItem(item) {
    const value = item.getAttribute("data-value") || item.textContent?.trim() || "";
    this.changeEvent.emit({
      value
    });
    this.closeOpenMenu(true);
  }
  static {
    _initClass();
  }
}
export { _RuiMenubar as RuiMenubar };